<div class="chips-container">
    <div class="chip" *ngFor="let i of chipsList">
        <span class="employee-name">{{ i.firstName }} {{ i.lastName }}</span>
        <button type="button" class="icon-cross_16px" (click)="removeChip(i)" style="border:none;background:transparent;padding:0;"></button>
    </div>
</div>
